<div class=" o-modal--medium" id="mod-qual">
  <div class="o-modal__head o-modal__head--red"><a class="o-modal__close close-modal" matDialogClose></a>
    <label class="o-title o-title--white o-title--medium">{{ 'ModalObsPolicyPortal.title' | translate }}</label>
  </div>
  <mat-dialog-content style="width:95%; margin: 20px;">
    <div class="o-modal__text">
    <ul class="o-modal__qualifications">
      <div *ngIf="data.length>0">
      <li *ngFor=" let obs of data"> 
        <i *ngIf="obs.status.name==='Reject'" class="icon icon-close"></i>
        <i *ngIf="obs.status.name==='Approved'" class="icon icon-check"></i>
        <i *ngIf="obs.status.name==='Scaled'" class="icon icon-arrow" style=" transform: rotateY(180deg);"></i>
      <p class="u-mb0"> {{obs.people.name}}</p>
      <p class="u-mb10">{{obs.createdAt | date: 'dd/MM/yyyy'}}</p>
      <h6>{{obs.description}}</h6>
      </li>
    </div>
    <div *ngIf="data.length===0">
      <h3 > {{'ModalObsPolicyPortal.bodyNot' | translate}}</h3>
    </div>
      <!--<li> <i class="icon icon-check icon--warning"></i>-->
    
    </ul>
    </div>
  </mat-dialog-content>
  </div>
